/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profilelinkdisconnect2Inputs */

const en_profilelinkdisconnect2 = /** @type {(inputs: Profilelinkdisconnect2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disconnect`)
};

const de_profilelinkdisconnect2 = /** @type {(inputs: Profilelinkdisconnect2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trennen`)
};

/**
* | output |
* | --- |
* | "Disconnect" |
*
* @param {Profilelinkdisconnect2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const profilelinkdisconnect2 = /** @type {((inputs?: Profilelinkdisconnect2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profilelinkdisconnect2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_profilelinkdisconnect2(inputs)
	return de_profilelinkdisconnect2(inputs)
});
export { profilelinkdisconnect2 as "profileLinkDisconnect" }